import { DataBean } from "../../DataBean";


export class ExportProvision extends DataBean {

    public async exportProvisionsSpreadSheet(idProvisionData: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportProvisionsSpreadSheet_Number_Number", [idProvisionData, idEmployee]);
    }

}